<template>
    <div style="display: flex;">
        <div class="chart_box" style="width: 50%; margin-right: 20px;">
            <el-card style="width: 100%; height: 100%; border-radius: 15px;">
                <p style="font-size: 20px; font-weight: 600; color: #81d3f8;">学生未到校趋势图</p>
                <div ref="attendance" style="width: 100%; height: 380px;"></div>
            </el-card>
        </div>

        <div class="chart_box" style="width: 50%;">
            <el-card style="width: 100%; height: 100%; border-radius: 15px;">
                <p style="font-size: 20px; font-weight: 600; color: #81d3f8;">事件趋势图</p>
                <div ref="event" style="width: 100%; height: 380px;"></div>
            </el-card>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { dataBoardAttendance } from '@/api/index'
import { dataBoardWarn } from '@/api/index'
import { unionHomeApi } from '@/api/index'
// import 'echarts/lib/chart/line'  // 导入折线图
export default {
    props: {
        schoolId: {
            type: String,
        }
    },
    data() {
        return {
            dateData: [], // 学生未到校日期
            valueData: [], // 学生未到校人数

            eventData: [], // 事件日期
            processedEvent: [], // 已处理事件
            unprocessedEvent: [], // 未处理事件
        }
    },
    mounted() {
        // this.dataBoardAttendance()
        // this.dataBoardWarn()
        // this.eventChart()
        this.change();
    },
    methods: {
        // 学生未到校图表数据
        initChart() {
            const chartEl = this.$refs.attendance  // 获取对应的DOM元素
            const chart = echarts.init(chartEl)  // 创建 ECharts 实例

            // 设置图表配置项和数据
            const options = {
                legend: {},
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        // crossStyle: {
                        //     color: '#999'
                        // },
                    },
                },
                dataset: {
                    dimensions: ['day', '病假', '事假', '休学'],
                    source: this.valueData,
                },
                xAxis: { type: 'category' },
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: function (value) {
                                // 将 value 转为字符串形式
                                const stringValue = value.toString();
                                // 检查是否包含小数点
                                if (stringValue.includes('.')) {
                                    // 返回空字符串，以隐藏小数点及其后的部分
                                    return '';
                                } else {
                                    // 返回整数部分
                                    return Math.floor(value);
                                }
                            }
                        }
                    },
                ],
                series: [
                    {
                        type: 'bar',
                        tooltip: {
                            valueFormatter: function (value) {
                                return value + ' 人';
                            }
                        },
                    },
                    {
                        type: 'bar',
                        tooltip: {
                            valueFormatter: function (value) {
                                return value + ' 人';
                            }
                        },
                    },
                    {
                        type: 'bar',
                        tooltip: {
                            valueFormatter: function (value) {
                                return value + ' 人';
                            }
                        },
                    }
                ]
            }

            chart.setOption(options)  // 设置图表配置项

            // 监听窗口大小变化，自适应图表
            window.addEventListener('resize', () => {
                chart.resize()
            })
        },

        // 事件趋势图
        eventChart() {
            const chartEl = this.$refs.event  // 获取对应的DOM元素
            const chart = echarts.init(chartEl)  // 创建 ECharts 实例

            // 设置图表配置项和数据
            const options = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        // crossStyle: {
                        //     color: '#999'
                        // },
                    },
                    formatter: '{b0}<br />{a0}: {c0}<br />{a1}: {c1}',
                },
                legend: {
                    data: ['已处理事件', '未处理事件']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.eventData,
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: function (value) {
                                // 将 value 转为字符串形式
                                const stringValue = value.toString();
                                // 检查是否包含小数点
                                if (stringValue.includes('.')) {
                                    // 返回空字符串，以隐藏小数点及其后的部分
                                    return '';
                                } else {
                                    // 返回整数部分
                                    return Math.floor(value);
                                }
                            }
                        }
                    },

                ],
                series: [
                    {
                        name: '已处理事件',
                        type: 'bar',
                        // tooltip: {
                        //     valueFormatter: function (value) {
                        //         return value + ' ml';
                        //     }
                        // },
                        data: this.processedEvent,
                        itemStyle: {
                            color: '#67C23A'
                        }
                    },
                    {
                        name: '未处理事件',
                        type: 'bar',
                        data: this.unprocessedEvent,
                        // itemStyle: {
                        //     color: '#a90000'
                        // }
                    },
                    {
                        name: '已处理事件',
                        type: 'line',
                        data: this.processedEvent,
                        itemStyle: {
                            color: '#67C23A'
                        }
                    },
                    {
                        name: '未处理事件',
                        type: 'line',
                        data: this.unprocessedEvent
                    }
                ]
            }

            chart.setOption(options)  // 设置图表配置项

            // 监听窗口大小变化，自适应图表
            window.addEventListener('resize', () => {
                chart.resize()
            })
        },

        async change(e) {
            let data = {
                school_id: e,
            }
            const res = await this.axios.post(unionHomeApi, data);
            if (res.data.code == 1) {
                const data = res.data.data.student
                this.eventData = res.data.data.rising.axis_name  // 事件日期
                this.processedEvent = res.data.data.rising.dispose_value // 已处理事件
                this.unprocessedEvent = res.data.data.rising.undisposed_value // 未处理事件
                // data.forEach(item => {
                //     this.dateData.push(item.name) // 学生未到校日期
                //     this.valueData.push(item.value * 1) // 学生未到校人数
                // })
                this.valueData = data.source

                this.initChart()
                this.eventChart()
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },

        // // 到校情况
        // async dataBoardAttendance() {
        //     const res = await this.axios.post(dataBoardAttendance);
        //     if (res.data.code == 1) {
        //         const data = res.data.data.student
        //         this.eventData = res.data.data.rising.axis_name  // 事件日期
        //         this.processedEvent = res.data.data.rising.dispose_value // 已处理事件
        //         this.unprocessedEvent = res.data.data.rising.undisposed_value // 未处理事件
        //         // data.forEach(item => {
        //         //     this.dateData.push(item.name) // 学生未到校日期
        //         //     this.valueData.push(item.value * 1) // 学生未到校人数
        //         // })
        //         this.valueData = data.source

        //         this.initChart()
        //         this.eventChart()
        //     } else {
        //         this.$message({
        //             showClose: true,
        //             message: res.data.msg,
        //             type: 'error'
        //         });
        //     }
        // },

        // // 预警处理数量
        // async dataBoardWarn() {
        //     const res = await this.axios.post(dataBoardWarn);
        //     if (res.data.code == 1) {
        //         this.eventData = res.data.data.rising.axis_name  // 事件日期
        //         this.processedEvent = res.data.data.rising.dispose_value // 已处理事件
        //         this.unprocessedEvent = res.data.data.rising.undisposed_value // 未处理事件

        //         this.eventChart()
        //     } else {
        //         this.$message({
        //             showClose: true,
        //             message: res.data.msg,
        //             type: 'error'
        //         });
        //     }
        // },
    },
}
</script>

<style lang="scss" scoped>
.chart_box {
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/homePage/educationHomePage/echartsData.vue